"use client";
import { supabase } from "@/lib/supabase";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import Messages from "./messages";
import { useAuth } from "@/providers/AuthProvider";
import Link from "next/link";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const { session } = useAuth();
  console.log(session);

  useEffect(() => {
    if (session) router.push("/");
  }, [session]);
  // Sign In Function
  const handleSignIn = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      setMessage(error.message);
      setLoading(false);
      return;
    }

    setLoading(false);
  };

  // Sign Up Function
  // const handleSignUp = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   setMessage("");

  //   if (!email) {
  //     setMessage("Email is required");
  //     setLoading(false);
  //     return;
  //   }

  //   if (!password) {
  //     setMessage("Password is required");
  //     setLoading(false);
  //     return;
  //   }

  //   try {
  //     // Create user without Supabase email
  //     // const { data, error } = await supabase.auth.admin.createUser({
  //     //   email,
  //     //   password,
  //     //   email_confirm: false, // 🚀 Prevents Supabase from sending the verification email
  //     // });

  //     // if (error) {
  //     //   setMessage(error.message);
  //     //   return;
  //     // }
  //     const response = await fetch("/api/signup", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ email, password }),
  //     });

  //     const result = await response.json();
  //     if (!response.ok) {
  //       setMessage(result.error || "Signup failed");
  //       setLoading(false);
  //       return;
  //     }

  //     // const user_id = data.user?.id;
  //     const user_id = result.user?.id;
  //     console.log(user_id);

  //     if (user_id) {
  //       // Check if user_chat_limits record exists
  //       const { data: existingUserChatLimit, error: selectChatLimitError } =
  //         await supabase
  //           .from("user_chat_limits")
  //           .select("id")
  //           .eq("user_id", user_id)
  //           .maybeSingle();

  //       if (selectChatLimitError) {
  //         setMessage("Error checking user chat limits");
  //         return;
  //       }

  //       if (!existingUserChatLimit) {
  //         const { error: insertChatLimitError } = await supabase
  //           .from("user_chat_limits")
  //           .insert([
  //             {
  //               user_id,
  //               email,
  //               chat_count: 0,
  //               chat_limit: 10,
  //             },
  //           ]);

  //         if (insertChatLimitError) {
  //           setMessage(
  //             `Error inserting user chat limits: ${insertChatLimitError.message}`,
  //           );
  //           return;
  //         }
  //       }

  //       // Check if file_limit record exists
  //       const { data: existingFileLimit, error: selectFileLimitError } =
  //         await supabase
  //           .from("file_limit")
  //           .select("id")
  //           .eq("user_id", user_id)
  //           .maybeSingle();

  //       if (selectFileLimitError) {
  //         setMessage("Error checking file upload limits");
  //         return;
  //       }

  //       if (!existingFileLimit) {
  //         const { error: insertFileLimitError } = await supabase
  //           .from("file_limit")
  //           .insert([
  //             {
  //               user_id,
  //               file_count: 0,
  //               file_count_limit: 1,
  //             },
  //           ]);

  //         if (insertFileLimitError) {
  //           setMessage(
  //             `Error inserting file upload limits: ${insertFileLimitError.message}`,
  //           );
  //           return;
  //         }
  //       }

  //       // Send welcome email via SendGrid
  //       const response = await fetch("/api/sendemail", {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({ email, type: "welcome" }),
  //       });

  //       const result = await response.json();

  //       if (!response.ok) {
  //         setMessage(result.error || "Failed to send welcome email");
  //         setLoading(false);
  //         return;
  //       }

  //       setMessage("Sign-up successful! Check your email to verify.");
  //     }
  //   } catch (err) {
  //     setMessage("An unexpected error occurred");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleSignUp = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    if (!email) {
      setMessage("Email is required");
      setLoading(false);
      return;
    }

    if (!password) {
      setMessage("Password is required");
      setLoading(false);
      return;
    }

    try {
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
      });

      if (error) {
        setMessage(error.message);
        setLoading(false);
        return;
      }

      const user_id = data.user?.id;

      if (user_id) {
        // const { error: insertChatLimitError } = await supabase
        //   .from("user_chat_limits")
        //   .insert([{ user_id, email, chat_count: 0, chat_limit: 10 }]);

        // if (insertChatLimitError) {
        //   setMessage(
        //     `Error inserting user chat limits: ${insertChatLimitError.message}`,
        //   );
        //   return;
        // }

        // const { error: insertFileLimitError } = await supabase
        //   .from("file_limit")
        //   .insert([{ user_id, file_count: 0, file_count_limit: 1 }]);

        // if (insertFileLimitError) {
        //   setMessage(
        //     `Error inserting file upload limits: ${insertFileLimitError.message}`,
        //   );
        //   return;
        // }

        setMessage("Sign-up successful! Check your email to verify.");
      }
    } catch (err) {
      setMessage("An unexpected error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex-1 flex flex-col w-full px-8 sm:max-w-md justify-center gap-2">
      <form
        onSubmit={handleSignUp}
        className="flex-1 flex flex-col w-full justify-center gap-2 text-foreground"
      >
        <label className="text-md" htmlFor="email">
          Email
        </label>
        <input
          className="rounded-md px-4 py-2 bg-inherit border mb-4"
          type="email"
          name="email"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <label className="text-md" htmlFor="password">
          Password
        </label>
        <div className="relative">
          <input
            className="rounded-md px-4 py-2 bg-inherit border mb-4 w-full"
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button
            type="button"
            className="absolute right-2 top-2 text-sm text-gray-500 hover:text-gray-700"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? "Hide" : "Show"}
          </button>
        </div>

        <button
          type="submit"
          className="bg-black rounded px-4 py-2 text-white mb-2 text-center"
          disabled={loading}
        >
          Sign Up
        </button>
        <Link
          href={"/login"}
          className="border text-center border-gray-700 rounded px-4 py-2 text-black mb-2"
        >
          Sign In
        </Link>

        <button
          type="button"
          onClick={() => router.push("/auth/forgotpass")}
          className="border border-gray-700 rounded px-4 py-2 text-black"
        >
          Forgot Password?
        </button>
        <Link
          href="/terms"
          className="text-center text-sm text-gray-500 hover:text-gray-700 underline"
        >
          Terms and Conditions
        </Link>
        <Messages error={""} message={message} />
      </form>
    </div>
  );
}

// {await fetch("/api/sendemail", {
//   method: "POST",
//   headers: {
//     "Content-Type": "application/json",
//   },
//   body: JSON.stringify({ email, type: "welcome" }),
// });
// }
